var uploadData = {
  name: 'upload',
  data: [{
    listNameColor: '#4f7de7',
    listErrorColor: '#fd6868',
    cardFontAddIconFamily: 'iconfont-c7n',
    listProgressBGColor: '#4F7DE7',
    cardListTextMarginTop: '0.3rem',
    dragIconColor: '#4f7de7'
  }]
};
export default uploadData;